// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3Wcxf","selects":"Documents_selects__1AXDh"};